import React from 'react';
import {styles} from './InvoicePDFLayout';
import {Text, View} from '@react-pdf/renderer';
import {ViewColumn} from '../../../../../components/initial-plan/pdf/layout/PDFLayout';
import {IntlShape} from 'react-intl';
import Util from '../../../../../forecast-app/shared/util/util';
import {InvoicePDFDownloadModal_viewer} from './__generated__/InvoicePDFDownloadModal_viewer.graphql';

type InvoicePDFFooterProps = {
	invoiceData: InvoicePDFDownloadModal_viewer['invoice'];
	intl: IntlShape;
};

const InvoicePDFFooter = ({invoiceData, intl}: InvoicePDFFooterProps): JSX.Element => {
	if (invoiceData?.notes) {
		const notesHtml = Util.ConvertDraftJsToPlainText(invoiceData?.notes);

		return (
			<>
				<ViewColumn style={{flexGrow: 1, justifyContent: 'flex-end'}} />
				<ViewColumn style={{paddingTop: '20px', justifyContent: 'flex-end'}}>
					<View style={{flexGrow: 1}} />
					<View style={{borderBottom: '1px solid #D9D9D9', marginBottom: '5px'}} />
					<Text style={[styles.textMainBold10, {paddingBottom: '8px'}]}>
						{intl.formatMessage({id: 'common.notes'})}
					</Text>
					<Text style={styles.textMain}>{notesHtml}</Text>
				</ViewColumn>
			</>
		);
	} else {
		return <Text></Text>;
	}
};

export default InvoicePDFFooter;
